import React, { useState } from 'react';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { Button } from '@mui/material';
import { ConfirmationModal } from '../../components/ConfirmationModal';
import LoadMealBalanceByCardNo from './LoadMealBalanceByCardNo';
import { usePermission } from '../../hooks/usePermission';

type UploadByCardNoButtonProps = {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    renderButton?: boolean;
};

const UploadByCardNoButton = ({ open: controlledOpen, onOpenChange, renderButton = true }: UploadByCardNoButtonProps = {}) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : internalOpen;
    const setOpen = (v: boolean) => (isControlled ? onOpenChange?.(v) : setInternalOpen(v));
    const { hasPermission: canUploadByCardNo, isLoading: isUploadByCardNoPermissionLoading } = usePermission({
        code: 'Corporate.POST.Writing.YemekKartınaKartİleBakiyeYükleme',
    });

    if (isUploadByCardNoPermissionLoading || !canUploadByCardNo) {
        return null;
    }

    return (
        <>
            {renderButton && (
            <Button
                variant="outlined"
                startIcon={<CreditCardIcon />}
                onClick={() => setOpen(true)}
                sx={{
                    border: '1px solid',
                    borderColor: '#2563eb',
                    color: '#1d4ed8',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    textTransform: 'none',
                    borderRadius: 2,
                    px: 3,
                    py: 1.2,
                    background: 'white',
                    boxShadow: '0 4px 12px rgba(37, 99, 235, 0.10)',
                    flexShrink: 0,
                    '&:hover': {
                        background: 'rgba(37,99,235,0.08)',
                        borderColor: '#1d4ed8',
                        border: '1px solid',
                        transform: 'translateY(-1px)'
                       
                    },
                    transition: 'all 0.3s ease',
                    minWidth: 180,
                }}
            >
                Kart No ile Bakiye Yükle
            </Button>
            )}
            <ConfirmationModal
                isOpen={open}
                onClose={() => setOpen(false)}
                onConfirm={() => { }} // Boş fonksiyon, çünkü LoadMealBalanceByCardNo kendi confirm'ini yönetiyor
                title="Kart No ile Toplu Bakiye Yükle"
                isLoading={false}
                confirmButtonText="" // Boş string ile buton gizle
                closeButtonText="" // Boş string ile buton gizle
                optionalWidth="1200px"
                customHeaderStyle={{
                    background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                    titleColor: 'white',
                }}
            >
                <LoadMealBalanceByCardNo onClose={() => setOpen(false)} />
            </ConfirmationModal>
        </>
    );
};

export default UploadByCardNoButton;
